import { useContext, useEffect, useState } from "react"

// Context
import { UserContext } from "../../../../../context/userContext"
import Map from "react-map-gl"
import "mapbox-gl/dist/mapbox-gl.css"

import { MapBoxSetFocusedLocation } from "../../../../Referrals/Components/sharedFunctions"

export default function ReferralEntityFormMap({ long, lat, setHeight }) {
  const userCtx = useContext(UserContext)

  const [thisMap, setThisMap] = useState()
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (isLoaded && thisMap) {
      let longitude = long ? long : 0
      let latitude = lat ? lat : 0
      MapBoxSetFocusedLocation({
        focusLocation: { longitude, latitude },
        map: thisMap,
      })
    }
  }, [isLoaded, long, lat, thisMap])

  function onLoad(e) {
    setThisMap(e.target)
    setIsLoaded(true)

    return null
  }

  return (
    <Map
      mapboxAccessToken={userCtx.keys.getMapBoxKey()}
      initialViewState={{
        longitude: long ? long : 0,
        latitude: lat ? lat : 0,
        zoom: 14,
      }}
      longitude={long ? long : 0}
      latitude={lat ? lat : 0}
      reuseMap
      style={{ height: setHeight, minHeight: "150px" }}
      mapStyle="mapbox://styles/mapbox/streets-v9"
      onLoad={onLoad}
    />
  )
}
